exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.disclaimer-modal-content[data-v-a1ed3a12]{\r\n    padding: 16px;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    height: 100%;\r\n    box-sizing: border-box;\n}\n.disclaimer-modal-content h2[data-v-a1ed3a12]{\r\n    color: #3172DF;\r\n    font-weight: 600;\n}\n.disclaimer-modal-content p[data-v-a1ed3a12]{\r\n    text-align: left;\n}\n.disclaimer-modal-content .button[data-v-a1ed3a12]{\r\n    margin-top: auto;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a1ed3a12","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/inventory/price-disclaimer.vue
// module id = 641
// module chunks = 0